import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LoginForm } from "web-apps/company/components/login/loginForm.component";
import { ResetPasswordModal } from "web-apps/company/components/login/resetPasswordModal.component";
import {
  ForgotPasswordButton,
  ForgotPasswordRow,
  LoggedOutPageContainer,
  LoginContentWrapper,
  StyledTitle,
} from "web-apps/company/components/login/loginForm.styled";

export const LoginPage: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [email, setEmail] = useState("");

  return (
    <LoggedOutPageContainer>
      <LoginContentWrapper>
        <StyledTitle>{t("LoginCompany.CompanyLogin")}</StyledTitle>
        <LoginForm
          email={email}
          setEmail={setEmail}
          onCreateAccount={() => {
            history.push("./sign-up");
          }}
        />
      </LoginContentWrapper>
      <ForgotPasswordRow>
        <ForgotPasswordButton onClick={() => setPasswordModalOpen(true)}>
          {t("LoginCompany.ForgotPassword")}
        </ForgotPasswordButton>
      </ForgotPasswordRow>
      <ResetPasswordModal
        passwordModalOpen={passwordModalOpen}
        setPasswordModalOpen={setPasswordModalOpen}
        email={email}
        setEmail={setEmail}
      />
    </LoggedOutPageContainer>
  );
};
